// extracted by mini-css-extract-plugin
export default {"price":"xJHbkh"};